module.exports = __webpack_public_path__ + "img/1045990056.6439cd6b.jpg";